import {SortService, SearchCriteria} from '../../../util/sort.service';
import { Injectable, inject } from '@angular/core';
import * as XLSX from 'exceljs';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {
  private sortService = inject(SortService);

  constructor() { }

  addTableForCharts = async (wb: any, chartData: any, chartName: string, transPose: boolean = false, colLength: number = 30) => {
  return new Promise((resolve, reject) => {
    let tableData: any = []
    let tablerawData = chartData['dataTable'] ? chartData['dataTable'] : chartData;
    tablerawData.forEach((row: any[], rowIndex: number) => {
      tableData[rowIndex] = [];
      row.forEach((col: any, colIndex) => {
        tableData[rowIndex][colIndex] = col;
      });
    });
    
    let tableTranspose = transPose ? tableData[0].map((col, i) => tableData.map(row => row[i])) : tableData;

    const columns = tableTranspose[0];

    tableTranspose.splice(0, 1);
    tableTranspose.sort(this.sortFunction);
    tableTranspose.splice(0, 0, columns);
    
    // ExcelJS: Create worksheet and add data
    const ws = wb.addWorksheet(chartName);
    ws.addRows(tableTranspose);
    
    // ExcelJS: Set column widths for all columns
    const maxCols = Math.max(0, ...tableTranspose.map(r => r.length));
    ws.columns = Array.from({ length: maxCols }, () => ({ width: colLength }));
    
    resolve(wb);
  });
}

  addTableForChartsForArray = (wb: any, chartData: any[], chartName: string, colLength: number = 30) => {
  return new Promise((resolve, reject) => {
    // ExcelJS: Create worksheet and add data
    const ws = wb.addWorksheet(chartName);
    ws.addRows(chartData);
    
    // ExcelJS: Set column widths for all columns
    const maxCols = Math.max(0, ...chartData.map(r => r.length));
    ws.columns = Array.from({ length: maxCols }, () => ({ width: colLength }));
    
    resolve(wb);
  });
}

addTableForChartsFromjson = (wb: any, chartData: any, chartName: string, transPose: boolean = false, colLength: number = 30) => {
  return new Promise((resolve, reject) => {
    // ExcelJS: Create worksheet
    const ws = wb.addWorksheet(chartName);
    
    // Convert JSON to array of arrays (similar to json_to_sheet)
    if (Array.isArray(chartData) && chartData.length > 0) {
      // Extract headers from first object
      const headers = Object.keys(chartData[0]);
      
      // Add header row
      ws.addRow(headers);
      
      // Add data rows
      chartData.forEach(item => {
        const row = headers.map(header => item[header]);
        ws.addRow(row);
      });
      
      // Set column widths
      ws.columns = headers.map(() => ({ width: colLength }));
    }
    
    resolve(wb);
  });
}

sortFunction(a, b) {
  if (a[0] === b[0]) {
    return 0;
  }
  else {
    return (a[0] < b[0]) ? -1 : 1;
  }
}

exportAllCTVCharts(chartData: any[], clientName: string, dateTime: string, dataType: string = 'json') {
  // ExcelJS: Create new workbook
  const wb = new XLSX.Workbook();
  const fileName: string = `${clientName}-Insight Status Report-${dateTime}.xlsx`;

  var criteria: SearchCriteria = new SearchCriteria();
  criteria.sortColumn = 'createDate';
  criteria.sortDirection = 'asc';

  const sortedChartData = this.sortService.sort(criteria, chartData);

  let promises: any = [];
  sortedChartData.forEach(chart => {
    let chartName = chart.chartName;
    if (chartName.length > 29) {
      chartName = chartName.substring(0, 28); // Fixed: use substring instead of splice
    }
    dataType = chart.onlyTableData ? 'array' : dataType; // Device Type Summary Data

    if (dataType === 'json') {
      promises.push(this.addTableForChartsFromjson(wb, chart['dataTableTranspose']['dataSource'], chartName));
    } else {
      promises.push(this.addTableForChartsForArray(wb, chart['dataTableTranspose']['dataSource'], chartName));
    }
  });

  Promise.all(promises).then(done => {
    wb.xlsx.writeFile(fileName);
  });
}

  getWeekNumber=(startdate: string)=>{
    return moment(startdate, 'MM/DD/YYYY').week();
  }

}
